import { TypePolicies } from '@apollo/client'
import {
    listingMatchTypePolicy,
    listingSearchFieldPolicy,
} from './listing.policies'
import { nuggetTypePolicy } from './nugget.policies'
import { productFamilyTypePolicy } from './productFamily.policies'
import { professionalDisciplinePolicy } from './professionalDiscipline.policies'
import {
    projectSearchFieldPolicy,
    projectSearchMatchTypePolicy,
} from './project.policies'
import { projectElementNodeTypePolicy } from './projectElementNode.policies'
import { projectNuggetTypePolicy } from './projectNugget.policies'
import { projectProductFamilyTypePolicy } from './projectProductFamily.policies'
import { projectTeamPolicy } from './projectTeam.policies'
import { subscriptionInfoTypePolicy } from './subscriptionInfo.policies'
import { userWithProjectRoleResultsPolicy } from './userWithProjectRoleResults.policies'
import { workspaceTogglesPolicy } from './workspaceToggles.policies'

/*
 * For Reference
 * https://www.apollographql.com/blog/previewing-the-apollo-client-3-cache-565fadd6a01e/
 */

const typePolicies: TypePolicies = {
    /*
     * ROOT_QUERY contains all the fields/queries
     * Add to fields for Pagination, Data Normalization, etc
     */
    Query: {
        fields: {
            // Merge incoming partial writes instead of replacing — prevents MyActiveFirmInfoQuery
            // (which only fetches firmId + previewFeatures) from wiping bestPracticeProjectId
            // that was loaded by CurrentUserActiveFirmQuery.
            myActiveFirm: { merge: true },
            ...projectSearchFieldPolicy,
            ...listingSearchFieldPolicy,
        },
    },
    /*
     * Add below the types which have an identifier other than id
     * This is the replacement of dataIdFromObject as it will be deprecated
     * in future versions of @apollo/client
     */
    ...projectSearchMatchTypePolicy,
    ...listingMatchTypePolicy,
    ...projectElementNodeTypePolicy,
    ...productFamilyTypePolicy,
    ...projectProductFamilyTypePolicy,
    ...projectNuggetTypePolicy,
    ...nuggetTypePolicy,
    ...workspaceTogglesPolicy,
    ...professionalDisciplinePolicy,
    ...userWithProjectRoleResultsPolicy,
    ...projectTeamPolicy,
    ...subscriptionInfoTypePolicy,
}

export default typePolicies
